import React from 'react'
import lockIcon from '../images/locker.svg'

const anonymousQAStyles = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	fontSize: '15px',
	marginBottom: 25
}

const lockIconStyles = {
	marginRight: 5
}

const AnonymousQA = () => {
	return (
		<p style={anonymousQAStyles}>
			<img src={lockIcon} alt='lock-icon' style={lockIconStyles} />
			Anonymous Q&A
		</p>
	)
}

export default AnonymousQA
